import { Box, Typography } from "@mui/material";

import { g } from "./shared/tokens";

interface Props {
  title: string;
  description: string;
  icon: string;
}

const GamificationCardHeader = ({ title, description, icon }: Props) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "14px" }}>
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: g.radiusMd,
          background: g.primaryTint,
          color: g.primary,
          display: "grid",
          placeItems: "center",
          flexShrink: 0,
        }}
      >
        <Box component="i" className={icon} sx={{ fontSize: 18 }} />
      </Box>
      <Box>
        <Typography
          sx={{ fontSize: 18, fontWeight: 800, lineHeight: 1.2, color: g.text }}
        >
          {title}
        </Typography>
        <Typography sx={{ fontSize: 14, color: g.text2 }}>
          {description}
        </Typography>
      </Box>
    </Box>
  );
};

export default GamificationCardHeader;
